import React, { useState } from 'react';
import NoData from '../../components/NoData';
import moment from 'moment';
import reportService from '../../services/reportService';
import { LoadingSpinner } from '../../components';
import { setToastMessage } from '../../reducers/common.reducer';
import { useDispatch } from 'react-redux';
import { MdOutlineCheckCircleOutline, MdOutlineDoDisturb, MdOutlineDoNotDisturbOn, MdOutlineQueryBuilder, MdContentPasteSearch } from "react-icons/md";
import { ViewDetailsDialog } from '../reportByMix/components/ViewDetailsDialog';
import Tooltip from '@mui/material/Tooltip';
import HeaderTitle from '../../components/HeaderTitle';
import { useWindowWidth } from '@react-hook/window-size';
import ByVoucherMobile from './mobile/ByVoucherMobile';
import CustomSearchBtn from '../../components/CustomSearchBtn';

const ByVoucher = () => {
  const dispatch = useDispatch();
  const onlyWidth = useWindowWidth();
  const [isLoading, setIsLoading] = useState(false);
  const [voucher, setVoucher] = useState("");
  const [voucherList, setVoucherList] = useState([]);
  const [currentBalance, setCurrentBalance] = useState(0);
  const [isReject, setIsReject] = useState(false);
  const [winAmount, setIsWinAmount] = useState(0);
  const [openView, setOpenView] = useState(false);
  const [detailsData, setDetailsData] = useState();

  const fetchData = async () => {
    try {
      if (voucher === "") {
        dispatch(setToastMessage({ type: "error", message: "Please enter voucher name!" }));
        return;
      }
      setIsLoading(true);
      const response = await reportService.reportByVoucher(voucher);

      if (response.status === 200) {
        if (response.data.data) {
          setVoucherList(response.data.data);
          setCurrentBalance(response.data.currentBalance);
          setIsReject(response.data.isReject);
          setIsWinAmount(response.data.winAmount);
        }
        else {
          dispatch(setToastMessage({ type: "error", message: response.data.message }));
          setVoucherList([]);
          setCurrentBalance(0);
          setIsReject(false);
          setIsWinAmount(0);
        }
      }
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const fetchDetailsData = async (id) => {
    try {
      setOpenView(true);
      setIsLoading(true);
      const response = await reportService.reportByMixDetailsVoucer(id);

      if (response.status === 200) {
        setDetailsData(response?.data.viewDetails);
      }
    }
    catch (error) {
      console.log("error", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <div className='overflow-x-auto'>
      <div className='my-1'>
        <HeaderTitle title={"Voucher Details"} />
      </div>
      <ViewDetailsDialog open={openView} setOpen={setOpenView} detailsData={detailsData} loading={isLoading} />
      <section className="flex justify-center customFontRoboto text-xs mt-3 px-3">
        <div className='w-full'>
          <div className='w-[340px] flex gap-1 justify-between'>
            <input className='w-full py-2 px-2 bg-customTitleColor dark:bg-custom_dark_primary2 dark:border-custom_dark_secondary dark:text-customLightMilkWhite focus:outline-none rounded-sm border border-hidden'
              placeholder='Search by Voucher ID'
              onChange={(e) => setVoucher(e.target.value)}
            />
            {/* <button className="text-white bg-black px-7 py-2 rounded-sm" onClick={() => fetchData()}>
              Search
            </button> */}
            <CustomSearchBtn handleSearch={fetchData} color='customAccentBlue'/>
          </div>

        </div>
      </section>
      {
        onlyWidth > 768 ?
          <div className="flex justify-center mt-4 px-3">
            <table className="w-full">
              <thead>
                <tr className="text-sm h-14 bg-custom_dark_primary dark:bg-custom_dark_secondary/60 text-customLightMilkWhite tracking-wide">
                  <th className="w-40">VoucherId</th>
                  <th className="w-48">Date/Time</th>
                  <th className="w-56">User ID</th>
                  <th className="w-48">User Name</th>
                  <th className="w-48">Game Type</th>
                  <th className="w-48">Bet Amount</th>
                  <th className="w-48">Status</th>
                  <th className="w-40">Win Amount</th>
                  <th className="w-40">Current Amount</th>
                  <th className="w-80">Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  isLoading ? <LoadingSpinner /> :
                    voucherList.length > 0 ?
                      voucherList.map((el, i) => {
                        return (
                          <tr className="customFontRoboto text-[0.8rem] h-16 border-b-2 border-customTitleColor font-semibold" key={i}>
                            <td className='text-center px-2 dark:text-customMuted'>
                              {el.postingNo}
                            </td>
                            <td className='text-center px-2 dark:text-customMuted'>
                              <p>{moment(el.createdDate).format("YYYY-MM-DD")}</p>
                              <p>{moment(el.createdDate).format("hh:mm a")}</p>
                            </td>
                            <td className="text-center px-2 dark:text-customMuted">
                              {el.username}
                            </td>
                            <td className="text-center px-2 dark:text-customMuted">
                              {el.name}
                            </td>
                            <td className="text-center px-2 dark:text-customMuted">
                              {el.gamblingTypeId === "1" ? "Single" : "Mix"} ({el.teamCount})
                            </td>
                            <td className="text-center px-2 dark:text-customMuted">
                              {el.amount}
                            </td>
                            <td className={`text-end px-2 ${isReject ? 'text-customFontRed' : el.active ? 'text-yellow-600' : 'text-green-600'} font-semibold`}>
                              <div className='flex gap-1 items-center justify-center'>
                                <p>{el.active ? "Active" : "Finished"}</p>
                                {isReject ?
                                  <MdOutlineDoNotDisturbOn className='text-lg' /> :
                                  el.active ?
                                    <MdOutlineQueryBuilder className='text-lg' /> :
                                    <MdOutlineCheckCircleOutline className='text-lg' />
                                }
                              </div>
                            </td>
                            <td className="text-center px-2 text-green-700 font-semibold">
                              {winAmount}
                            </td>
                            <td className="text-end px-2 font-semibold dark:text-customMuted">
                              {currentBalance}
                            </td>
                            <td className="flex justify-center items-center h-16">
                              <div className="flex justify-evenly items-center w-[80%] cursor-pointer" >
                                <Tooltip title="View Details" placement="top" arrow>
                                  <span>
                                    <MdContentPasteSearch className='text-2xl text-customFontVoilet' onClick={() => fetchDetailsData(el.gamblingId)} />
                                  </span>
                                </Tooltip>
                                <Tooltip title="Reject" placement="top" arrow>
                                  <span>
                                    <MdOutlineDoDisturb className='text-2xl text-customFontVoilet' />
                                  </span>
                                </Tooltip>
                                {/* <Link href="./BetDetailsSingleByEvent.html">
                      <img className="w-7" src={highImportant} alt="" />
                    </Link> */}
                              </div>
                            </td>
                          </tr>
                        )
                      }) :
                      <tr>
                        <td colSpan={10}><NoData /></td>
                      </tr>
                }
              </tbody>
            </table>
          </div> :
          <ByVoucherMobile isLoading={isLoading} voucherList={voucherList} winAmount={winAmount} currentBalance={currentBalance} />
      }
    </div>
  )
}

export default ByVoucher